import { createSlice } from "@reduxjs/toolkit";

const successAlert = createSlice({
  name: "successAlert",
  initialState: { toggle: false},
  reducers: {
    open: (state, action) => {
      state.toggle = action.payload.value;

    },
    close: (state, action)=>{
      state.toggle = action.payload.value;
    }
  }
})

export const { open, close } = successAlert.actions;
export default successAlert.reducer;
